<template>
  <tr>
    <th class="subsearch-toggle-area-bar">
      <div class="subsearch-toggle-area-suba" :class="{selected: accordion}" v-on:click="activeAccordion(areaId)"></div>
      <div class="checkbox">
        <input
          v-model="selectedAreaId"
          :id="`area_${props.areaId}`"
          class="css-checkbox"
          type="checkbox"
          >
          <label :for="`area_${props.areaId}`" class="css-label">&nbsp;{{ props.areaName }}</label>
      </div>
    </th>

    <transition name="trans_slide">
    <td :id="countCheckId" class="subsearch-toggle-area-subb">
      <div v-for="prefecture in props.prefectures" class="checkbox">
        <input
          type="checkbox"
          v-model="checkboxesValues"
          :name="`area_${props.areaId}`"
          :class="`css-checkbox area_${props.areaId}`"
          :value="prefecture.id"
          :id="`prefecture_id_${prefecture.id}`" >
          <label
            class="css-label"
            :for="`prefecture_id_${prefecture.id}`">
            {{ prefecture.name }}
          </label>
      </div>
    </td>
    </transition>
  </tr>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  areaId: { type: Number, required: true },
  areaName: { type: String, required: true },
  prefectures: { type: Array, required: true},
  checkedIds: { type: Array }
})
const emit = defineEmits(['updateValue'])

const accordion = ref(false)
const checkboxesValues = ref(props.checkedIds)

const allPrefectureId = computed(() => {
  var ids = []
  props.prefectures.some(prefecture => { ids.push(prefecture.id)})
  return ids
})

const selectedAreaId = computed({
  get: () => checkboxesValues.value.length === props.prefectures.length,
  set: (checked) => checkboxesValues.value = (checked ? allPrefectureId.value : [])
})

const countCheckId = computed(() => 'area_' + props.areaId + '_for_count_check')

watch(() => props.checkedIds, () => {
  checkboxesValues.value = props.checkedIds
})

watch(checkboxesValues, () => {
  emit('updateValue', props.areaId, checkboxesValues.value)
})

const activeAccordion = () => {
  accordion.value = !accordion.value
  /* FIXME: スライドのアニメーション実装にかなり工数が必要なため
    * 今回はjQueryで実装しています。
    * [要修正] 2020/05/14 isoshima
    */
  $('#' + countCheckId.value).slideToggle()
}
</script>
